import { Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type, lambda_type, unit_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Page_$reflection } from "../Routing.js";
import { createElement } from "react";
import React from "react";
import { length, ofArray, singleton as singleton_1, append as append_1, isEmpty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { map, defaultArgWith, value as value_59 } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { map as map_1, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { icon } from "./Icon.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { Router_goToUrl, $007CPageUrl$007C } from "../Routing.js";
import { RouterModule_trySeparateLast, RouterModule_encodeQueryString, RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";

export class FilterAction$1 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Click", "NavigateToPage"];
    }
}

export function FilterAction$1_$reflection(gen0) {
    return union_type("Shopfoo.Client.Components.FilterAction`1", [gen0], FilterAction$1, () => [[["onClick", lambda_type(gen0, unit_type)]], [["getPage", lambda_type(gen0, Page_$reflection())]]]);
}

export function Filter_FilterTab_Z754DA2F2(filter_FilterTab_Z754DA2F2InputProps) {
    let elems_6, elems_5, elems_2, elems_1, elems, elems_4;
    const onReset = filter_FilterTab_Z754DA2F2InputProps.onReset;
    const onSelect = filter_FilterTab_Z754DA2F2InputProps.onSelect;
    const formatItem = filter_FilterTab_Z754DA2F2InputProps.formatItem;
    const selectedItem = filter_FilterTab_Z754DA2F2InputProps.selectedItem;
    const items = filter_FilterTab_Z754DA2F2InputProps.items;
    const iconifyIcon = filter_FilterTab_Z754DA2F2InputProps.iconifyIcon;
    const label = filter_FilterTab_Z754DA2F2InputProps.label;
    const key = filter_FilterTab_Z754DA2F2InputProps.$key;
    if (isEmpty(items)) {
        return defaultOf();
    }
    else if (selectedItem != null) {
        const selectedItem_1 = value_59(selectedItem);
        return createElement("div", createObj(ofArray([["key", `${key}-tab`], ["className", "tab tab-active gap-2 !px-3 before:!w-[calc(100%-26px)] before:!left-[10px]"], (elems_6 = toList(delay(() => {
            let matchValue_3;
            return append((matchValue_3 = iconifyIcon, (matchValue_3 != null) ? singleton(icon(matchValue_3)) : (empty())), delay(() => append(singleton(formatItem(selectedItem_1)), delay(() => singleton(createElement("a", createObj(Helpers_combineClasses("btn", toList(delay(() => append(singleton(["key", `${key}-tab-close-button`]), delay(() => append(singleton(["className", "btn btn-ghost btn-sm btn-circle ml-[-4px]"]), delay(() => append(singleton(["children", "✕"]), delay(() => {
                let pageUrl_1, queryString_1;
                const matchValue_4 = onReset;
                if (matchValue_4.tag === 1) {
                    return (pageUrl_1 = $007CPageUrl$007C(matchValue_4.fields[0]()), ofArray([["href", (queryString_1 = pageUrl_1.Query, defaultArgWith(map((tupledArg_1) => RouterModule_encodeParts(append_1(tupledArg_1[0], singleton_1(tupledArg_1[1] + RouterModule_encodeQueryString(queryString_1))), 2), RouterModule_trySeparateLast(pageUrl_1.Segments)), () => RouterModule_encodeParts(singleton_1(RouterModule_encodeQueryString(queryString_1)), 2)))], ["onClick", (e_1) => {
                        Router_goToUrl(e_1);
                    }]]));
                }
                else {
                    return singleton(["onClick", (_arg_3) => {
                        matchValue_4.fields[0]();
                    }]);
                }
            }))))))))))))))));
        })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
    }
    else {
        return createElement("div", createObj(Helpers_combineClasses("dropdown", ofArray([["className", "dropdown-hover"], ["key", `${key}-dropdown`], (elems_5 = [createElement("a", createObj(Helpers_combineClasses("btn", ofArray([["className", "btn-link"], ["key", `${key}-dropdown-button`], ["className", "tab h-full !font-normal !no-underline"], (elems_2 = [createElement("div", createObj(Helpers_combineClasses("indicator", ofArray([["key", `${key}-dropdown-indicator`], (elems_1 = [createElement("div", createObj(Helpers_combineClasses("indicator-item", ofArray([["key", `${key}-dropdown-badge`], ["className", "badge badge-sm badge-primary badge-soft px-1"], ["children", length(items)]])))), createElement("div", createObj(ofArray([["key", `${key}-dropdown-button-content`], ["className", "flex items-center gap-2 pr-3"], (elems = toList(delay(() => {
            let matchValue_1;
            return append((matchValue_1 = iconifyIcon, (matchValue_1 != null) ? singleton(icon(matchValue_1)) : (empty())), delay(() => singleton(label)));
        })), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), createElement("ul", createObj(Helpers_combineClasses("dropdown-content", ofArray([["key", `${key}-dropdown-content`], ["className", "menu p-2 shadow bg-base-100 rounded-box w-52"], (elems_4 = toList(delay(() => map_1((item) => {
            let elems_3;
            const itemLabel = formatItem(item);
            return createElement("li", createObj(ofArray([["key", `${key}-menu-item-${itemLabel}-li`], (elems_3 = [createElement("a", createObj(toList(delay(() => append(singleton(["key", `${key}-menu-item-${itemLabel}-a`]), delay(() => append(singleton(["children", itemLabel]), delay(() => {
                let pageUrl, queryString;
                const matchValue_2 = onSelect;
                if (matchValue_2.tag === 1) {
                    return (pageUrl = $007CPageUrl$007C(matchValue_2.fields[0](item)), ofArray([["href", (queryString = pageUrl.Query, defaultArgWith(map((tupledArg) => RouterModule_encodeParts(append_1(tupledArg[0], singleton_1(tupledArg[1] + RouterModule_encodeQueryString(queryString))), 2), RouterModule_trySeparateLast(pageUrl.Segments)), () => RouterModule_encodeParts(singleton_1(RouterModule_encodeQueryString(queryString)), 2)))], ["onClick", (e) => {
                        Router_goToUrl(e);
                    }]]));
                }
                else {
                    return singleton(["onClick", (_arg) => {
                        matchValue_2.fields[0](item);
                    }]);
                }
            }))))))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
        }, items))), ["children", reactApi.Children.toArray(Array.from(elems_4))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
    }
}

